export default "/icon_info.27e6a214-8c9fce.png";